import { Center, Image, Stack, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import illustrationError from '@/assets/images/illustration-error.png'

export default function EmptyState() {
  const t = useTranslations('stockTable')
  return (
    <Center p="16px">
      <Stack gap="12px" align="center">
        <Image src={illustrationError.src} alt="Empty" w="80px" />
        <Text variant="body-emphasis">{t('emptyTips')}</Text>
      </Stack>
    </Center>
  )
}
